// extracted by mini-css-extract-plugin
export default {"container":"_27yHB","title":"_3izgV","postsList":"_93NBZ","postListItem":"_2TlLc"};